import { render, staticRenderFns } from "./Baozha.vue?vue&type=template&id=8ac03de8&"
import script from "./Baozha.vue?vue&type=script&lang=js&"
export * from "./Baozha.vue?vue&type=script&lang=js&"
import style0 from "./Baozha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports